<template>
  <md-select
    :value="value"
    md-dense
    multiple
    :disabled="disabled"
    @md-selected="dosingTypeKeys => update(dosingTypeKeys)"
  >
    <md-option
      v-for="dosing of availableDosingTypes"
      :key="dosing.key"
      :value="dosing.key"
    >
      {{ dosing.label.en }}
    </md-option>
  </md-select>
</template>

<script>
import { infusionDosingTypes } from '~lib/common/config/medication';

export default {
  name: 'infusion-dosing-type-select',
  props: {
    value: {
      type: Array,
      required: false,
      default: () => null,
    },
    allowableDosingTypes: {
      type: Array,
      default: () => []
    }, 
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      infusionDosingTypes,
    };
  },
  computed: {    
    availableDosingTypes() {
      return infusionDosingTypes.filter(
        dosingTyp => this.allowableDosingTypes.length === 0 || this.allowableDosingTypes.includes(dosingTyp.key)
      )
    },
  },
  methods: {
    update(dosingTypeKeys) {
      this.$emit('input', dosingTypeKeys);
    },
  },
};
</script>

<style scoped></style>
